import React from 'react';
import { Clock } from 'lucide-react';
import { BUCKET_ORDER, BUCKET_META, fmtXof } from './recMeta';

// Mini-donut CSS (conic-gradient) représentant la part du bucket dans le total.
const Donut = ({ pct, color }) => (
  <div
    className="relative h-12 w-12 shrink-0 rounded-full"
    style={{ background: `conic-gradient(${color} ${pct * 3.6}deg, #e5e7eb 0deg)` }}
  >
    <div className="absolute inset-1.5 rounded-full bg-white" />
  </div>
);

// 4 cartes d'ancienneté cliquables (filtrent les factures).
export const AgingKpiCards = ({ bucketTotals = {}, bucketCounts = {}, activeBucket, onSelect }) => {
  const grandTotal = BUCKET_ORDER.reduce((a, k) => a + (bucketTotals[k] || 0), 0) || 0;
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4" data-testid="aging-kpi-cards">
      {BUCKET_ORDER.map((k) => {
        const meta = BUCKET_META[k];
        const total = bucketTotals[k] || 0;
        const count = bucketCounts[k] || 0;
        const pct = grandTotal ? Math.round((total / grandTotal) * 1000) / 10 : 0;
        const active = activeBucket === k;
        return (
          <button
            key={k}
            type="button"
            onClick={() => onSelect && onSelect(active ? null : k)}
            data-testid={`aging-card-${k}`}
            className={`rounded-xl border-2 p-4 text-left shadow-sm transition-all hover:shadow-md hover:-translate-y-0.5 ${meta.card} ${active ? 'ring-2 ring-offset-1 ring-gray-400' : ''}`}
          >
            <div className="flex items-start justify-between gap-2">
              <div className="min-w-0">
                <div className={`mb-1 flex items-center gap-1.5 text-xs font-semibold ${meta.icon}`}>
                  <Clock className="h-3.5 w-3.5" /> {meta.label}
                </div>
                <div className={`text-xl font-bold tracking-tight tabular-nums ${meta.value}`}>{fmtXof(total)}</div>
                <div className="mt-0.5 text-xs text-gray-500">
                  {count} facture{count > 1 ? 's' : ''}{grandTotal ? ` · ${pct}% du total` : ''}
                </div>
              </div>
              <Donut pct={pct} color={meta.ring} />
            </div>
            <span className={`mt-3 inline-flex rounded-md px-2 py-0.5 text-xs font-medium ${meta.riskBadge}`}>{meta.risk}</span>
          </button>
        );
      })}
    </div>
  );
};

export default AgingKpiCards;
